import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { TIER_META } from "../lib/tiers";
import { Stars } from "./MemberExtras";

export const WinnerReviews = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/reviews").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-10 py-20" data-testid="winner-reviews">
      <p className="eyebrow">From real voyagers</p>
      <h2 className="font-serif-lux text-3xl md:text-4xl mt-3">Trips our members took.</h2>
      <div className="mt-10 grid md:grid-cols-3 gap-5">
        {items.map((r) => (
          <div key={r.id} data-testid={`winner-review-${r.id}`} className="lux-card p-6">
            <Stars value={r.rating} tid={`winner-review-stars-${r.id}`} />
            <p className="text-sm text-slate-300 mt-4">"{r.text}"</p>
            <p className="text-xs text-slate-500 mt-4"><span className="text-[#38BDF8]">{r.alias}</span> · {r.vacation_title} · {TIER_META[r.tier]?.label || r.tier}</p>
          </div>
        ))}
      </div>
    </section>
  );
};
